import React, {useEffect, useState} from 'react';
import '@fortawesome/fontawesome-svg-core/styles.css'
import Header from "./Header";
import {serverHttpLinkString} from "../../config";
import {useDispatch} from "react-redux";
import {decodeJWTToken, setIsLoggedIn, setUser} from "../../store/actions/UserActions";
import jwt_decode from "jwt-decode";
import {NavLink, useLocation} from "react-router-dom";
import Draggable from "react-draggable";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faUpDownLeftRight, faArrowsMinimize, faArrowsMaximize} from "@fortawesome/pro-solid-svg-icons";
import {kickUsername, websiteName, twitterLink, kickLink, instaLink, discordLink, youtubeLink} from '../../config';
import Footer from "./Footer";

const Body = props => {
    const dispatch = useDispatch();
    const [showMiniplayer, setShowMiniplayer] = useState(true);
    const [fullwidth, setFullwidth] = useState(false);
    const location = useLocation();

    const handleEventListener = event => {
        const {token, ok, auth} = event.data;

        if (ok) {
            localStorage.setItem("jwtToken", token);
            const decodedToken = jwt_decode(token);
            dispatch(decodeJWTToken(token));
            dispatch(setUser(decodedToken.user));
            dispatch(setIsLoggedIn(true));
        }
    }

    const toggleMiniplayer = () => {
        setShowMiniplayer(!showMiniplayer);
    }

    useEffect(() => {
        fetch(`https://kick.com/api/v1/channels/${kickUsername}`)
            .then((response) => response.json())
            .then((data) => {
                if(data.livestream){
                    setShowMiniplayer(true);
                }else{
                    setShowMiniplayer(false);
                }
            });
    }, []);

    useEffect(() => {
        window.addEventListener("message", event => {
            if (event.origin != `${serverHttpLinkString}`) return;

            handleEventListener(event);
        });
    }, []);

    useEffect(() => {
        setFullwidth(false);
        if(location.pathname == '/'){
            setFullwidth(true);
        }
        if(location.pathname == '/leaderboard'){
            setFullwidth(true);
        }
    }, [location]);

    return (
        <>
            <div className="content">
                <Header/>
                <div className={fullwidth?``:`container`} style={{padding: fullwidth?'':'50px 0'}}>
                    {props?.children}
                </div>
                {/*<Draggable handle=".handle" defaultClassName={"hiddenMobile"}>*/}
                {/*    <div className={`draggableWrapper ${showMiniplayer?'shown':'hidden'}`}>*/}
                {/*        {showMiniplayer && <div className="handle"><FontAwesomeIcon icon={faUpDownLeftRight} /></div>}*/}
                {/*        <div className="close" onClick={toggleMiniplayer}>{showMiniplayer ? <FontAwesomeIcon icon={faArrowsMinimize} /> : <FontAwesomeIcon icon={faArrowsMaximize} />}</div>*/}
                {/*        {showMiniplayer && <div>*/}
                {/*            <iframe src={`https://player.kick.com/${kickUsername}`} frameborder="0" width="375" height="211"></iframe>*/}
                {/*        </div>}*/}
                {/*    </div>*/}
                {/*</Draggable>*/}
            </div>

            <Footer />
        </>
    )
};

export default Body;
